import { AppBar, IconButton, makeStyles } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import { Linked } from '@type-r/react';
import * as React from 'react';
import { OrderFilters, OrderModel } from 'api';
import {asDate, asDateTime, CsvDownloader, Flex, csvHyperlink, SelectSortBy, Toolbar, CsvMapping, AddFilter, FiltersList} from 'lqx-react';

export interface OrderSortOptions {
    attr : string
    asc : boolean
}

export interface SearchToolbarProps {
    omFilter : OrderFilters
    $sort : Linked<OrderSortOptions>
    $isGrid : Linked<boolean>
    download : OrderModel[]
    sortOptions : { [ attr : string ] : string }
}

export const SearchToolbar = ({ sortOptions, omFilter, $sort, $isGrid, download } : SearchToolbarProps ) => {
    const classes = useStyles();

    return <AppBar position="static" color="transparent">
        <Toolbar>
            <div className={classes.filterContainer}>
                <AddFilter filter={omFilter} filterAllPlaceholder="Filter PO#, SO#, Quote#, customer and supplier names" />
            </div>
            <Flex grow />

            <SelectSortBy $attr={ $sort.at( 'attr' ) } $asc={ $sort.at( 'asc' ) } options={ sortOptions } />

            <CsvDownloader filename="orders" mapping={ csvFields } data={ download }>
                <IconButton aria-label="Download" size="small">
                    <GetAppIcon/>
                </IconButton>
            </CsvDownloader>

            <IconButton size="small" onClick={ () => $isGrid.set( !$isGrid.value )}>
                <ViewColumnIcon/>
            </IconButton>
        </Toolbar>
        <FiltersList filter={omFilter} />
    </AppBar>
}

const csvFields : CsvMapping<OrderModel> ={
    "Status" : "status",
    "Distributor Name" : x => x.customerName,
    "Supplier Name": x => x.supplier && x.supplier.name,
    "Quote #" : x => x.quote.id,
    "Quote Transaction Time" : x => asDateTime( x.quote.transaction_time ),
    "PO #" :"po_number",
    "SO #": "sales_order_id",
    "Total Price": "total_price",
    "Flags": "displayFlags",
    "Created On":  x => asDateTime( x.created_on_utc ),
    "Updated On":  x => asDateTime( x.last_updated ),
    "PO Date" : x => asDate( x.po_details.po_date ),
    "Order Details URL": x => csvHyperlink([window.location.href, x.id].join('/'))
}

const useStyles = makeStyles({    
    filterContainer: {
        minWidth: "450px"
    }
});
